"use client";
import { ICPServiceOtherType1 } from "@/types/global";
import Hyperlink from "../../ui/hyperlink";

interface Props {
    data: ICPServiceOtherType1;
    i?: number;
    onModalOpen?: (modalTitle?: string) => void;
}

const ServiceAreaOtherCard = ({ data, onModalOpen }: Props) => {
    return (
        <div className="col-md-6 col-xl-4 d-flex">
            <div className="desilo-service-box6 bg-color-white move-anim h-100 d-flex flex-column w-100">
                <div className="h-100 d-flex flex-column">
                    <div className="service-icon">
                        <i className={data.icon}></i>
                    </div>
                    <div className="service-content h-100 d-flex flex-column justify-content-between">
                        <div>
                            <h3>{data.title}</h3>
                            <p>{data.description}</p>
                        </div>
                        <div className="row row-padding-top">
                            <div className="col-12 text-left">
                                <Hyperlink
                                    variant="modal-pill"
                                    onModalOpen={onModalOpen}
                                    modalTitle="Learn More"
                                    aria-label={`Learn more about our ${data.title} services`}
                                >
                                    Learn More
                                </Hyperlink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceAreaOtherCard;
